'use strict';

import React, { Component } from 'react'

import Button from '@material-ui/core/Button'

import Link from '@Pure/Link'

import bemit from '@function/bemit'

import { isTrue } from '@root/utility'

let app = window.app;

export default class FrontHeader extends Component
{
	state =
	{
		loading: false
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'documentClick',
			cb: component.handleDocClick
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'documentClick',
			cb: component.handleDocClick
		});
	}

	handleDocClick = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		if (data === 'FrontHeader') return;

		if (state.open_dropdown !== undefined)
		{
			component.setState({ open_dropdown: undefined });
		}
	}

	toggleDropDown = (e, name) =>
	{
		const component = this, props = this.props, state = this.state;

		e.stopPropagation();

		component.setState(
		{
			open_dropdown: state.open_dropdown !== name
			? name
			: undefined
		});
	}

	captureClick = (e) =>
	{
		e?.stopPropagation();

		app.emit('documentClick', 'FrontHeader');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let pathname = document.location.pathname;

		if (pathname === '/accueil') pathname = '/';

		const session = app.state.session || { };

		const has_partners_access = session.partners?.length > 0;

		const items = Object.keys(props.links).map(function (name)
		{
			const infos = props.links[name];

			if (infos.partner === true && !has_partners_access)
			{
				return null;
			}

			if (infos.admin_users_only === false)
			{
				if (!session.EC) return null;

				if (isTrue(session.EC.admin_users_only)) return null;
			}

			let is__active = false;

			if (['/', '/accueil'].includes(infos.url))
			{
				is__active = pathname === '/';
			}
			else if (infos.url === pathname || pathname.startsWith(infos.url))
			{
				is__active = true;
			}

			const sub_items = Object.keys(infos.sub_items || { })
			.map(function (name)
			{
				const item = infos.sub_items[name];

				if (item.admin_users_only === false)
				{
					if (!session.EC) return null;

					if (isTrue(session.EC.admin_users_only)) return null;
				}

				let class_name = 'c-menu-item__subitem';

				if (item.url === pathname)
				{
					is__active = true;

					class_name += ' active';
				}

				let output =
				(
					<li className={ class_name } key={ item.url }>

						<Link className="c-menu-item__subitem-link"
							href={ item.url }
							rel="noopener noreferrer">

							{ item.label }

						</Link>

					</li>
				);

				return output;
			});

			let modifiers = is__active === true ? ['active'] : [];

			let onClick;

			if (infos.sub_items)
			{
				modifiers.push('dropdown');

				onClick = (e) => component.toggleDropDown(e, name);

				if (state.open_dropdown === name) modifiers.push('open');
			}

			const link_element = modifiers.includes('active') && !sub_items.length
			? <div className="c-menu-item__link">{ infos.label }</div>
			:
			(
				<Button className="c-menu-item__link" onClick={ onClick }
					href={ onClick ? undefined : infos.url }
					component={ Link }>

					{ infos.label }

				</Button>
			);

			let output =
			(
				<li className={ bemit('c-menu-item', modifiers) } key={ infos.url }>

					{ link_element }

					{
						sub_items.length > 0 ?
						(
							<ul role="menu" className="c-menu-item__menu">
								{ sub_items }
							</ul>
						)
						: undefined
					}

				</li>
			);

			return output;
		})
		.filter(item => item);

		let output =
		(
			<nav className="o-navbar__nav">
				<ul className="o-navbar__menu" onClick={ component.captureClick }>
					{ items }
				</ul>
			</nav>
		);

		return output;
	}
}